// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"Vcf"};